import { CalculatedConsumablesDemandThemeSizeConfig } from './types';

const medium: CalculatedConsumablesDemandThemeSizeConfig = {
  calculatedConsumablesDemand: {},
};

export default medium;
